import { getSeasons, getSupplier, getUserSuppliers as getUserSuppliersService } from '../../../services/supplierSuggestion.service';
import { getAllBrands, getAllCategory } from '../../../services/supplier.service';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { getCompanyUsers as getCompanyUsersService, getMyTodoFilterMasters } from './TodoCommon.service';
import SystemMasterType from '../../SystemMasters/Store/SystemMasters.type';
import DevOrderType from '../../DevlopmentOrder/store/DevelopmentOrder.type';
import BomLibraryType from '../../Library/BomLibrary/store/BomLibrary.type';
import ColorLibraryType from '../../Library/ColorLibary/store/ColorLibrary.type';

/** Sort a list by its keyName field, case-insensitively. */
const sortByKeyName = (list) => [...(list || [])].sort((a, b) => (a.keyName || '').localeCompare(b.keyName || '', 'en', { sensitivity: 'base' }));

export const getSeasonsAction = (id) => async () => {
  try {
    const res = await getSeasons(id);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllBrandAction = (params) => async () => {
  try {
    const res = await getAllBrands(params);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSuppliers = (data) => async () => {
  try {
    const res = await getSupplier(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getUserSuppliers = () => async () => {
  try {
    const res = await getUserSuppliersService();
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCategoryAction = (params) => async () => {
  const setValueObj = (label, value) => {
    return { label, value };
  };
  try {
    const res = await getAllCategory(params);
    if (res.code === 200 && res.data) {
      await res.data.map((item) => {
        return setValueObj(item.label, item.value);
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getCompanyUsers = (data) => async () => {
  try {
    const res = await getCompanyUsersService(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

/**
 * Single aggregated load of all My Todo filter dropdown masters.
 * Fetches one endpoint and fans the response into the existing reducers using
 * their existing action types, replicating each original thunk's client-side
 * transform so every selector — and every other screen sharing these reducers —
 * behaves identically. Replaces ~14 parallel master calls with one round trip.
 */
export const loadMyTodoFilterMasters = (data) => async (dispatch) => {
  try {
    const res = await getMyTodoFilterMasters(data);
    if (res?.code !== 200 || !res.data) return;
    const filterMasters = res.data;

    // Plain lists — dispatched verbatim, exactly as their original thunks did.
    dispatch({ type: SystemMasterType.GET_ALL_BRANDS, payload: filterMasters.brands || [] });
    dispatch({ type: SystemMasterType.GET_ALL_SEASONS, payload: filterMasters.seasons || [] });
    dispatch({ type: SystemMasterType.GET_ALL_CATEGORY_1, payload: filterMasters.category1 || [] });
    dispatch({ type: SystemMasterType.GET_ALL_CATEGORY_2, payload: filterMasters.category2 || [] });
    dispatch({ type: SystemMasterType.GET_ALL_PC_TYPE, payload: filterMasters.productTypes || [] });
    dispatch({ type: SystemMasterType.GET_ALL_LICENSOR, payload: filterMasters.licensors || [] });
    dispatch({ type: DevOrderType.COMPANY_USER, payload: filterMasters.companyUsers || [] });
    dispatch({
      type: BomLibraryType.FETCH_REFERENCE_SUPPLIER,
      payload: filterMasters.referenceSupplier || [],
    });

    // Only-on-success dispatches (originals skipped the dispatch on failure).
    if (filterMasters.subBrandAccess != null) {
      dispatch({ type: SystemMasterType.GET_SUB_BRAND_ACCESS, payload: filterMasters.subBrandAccess });
    }
    if (filterMasters.adminUser != null) {
      dispatch({ type: DevOrderType.ADMIN_USER, payload: filterMasters.adminUser });
    }

    // PCP multi custom attributes — sort each attribute's values by keyName.
    const pcpCustomAttribute = (filterMasters.multiCustomAttribute || []).map((attr) => ({
      ...attr,
      values: sortByKeyName(attr.values),
    }));
    dispatch({ type: SystemMasterType.GET_PCP_CUSTOM_ATTRIBUTE, payload: pcpCustomAttribute });

    // Free-text custom attributes — labels first, then values sorted by keyName.
    const rawAttrs = filterMasters.customAttributeFreeText || [];
    const labels = rawAttrs.filter((item) => !item.lableId);
    const values = sortByKeyName(rawAttrs.filter((item) => item.lableId));
    dispatch({ type: SystemMasterType.CUSTOM_ATTRIBUTE_LIST, payload: [...labels, ...values] });

    // Colour lists — flag each item with isDisable:false, as their thunks do.
    dispatch({
      type: ColorLibraryType.FETCH_COLORS_LIST,
      payload: (filterMasters.colorWays || []).map((item) => ({ ...item, isDisable: false })),
    });
    dispatch({
      type: ColorLibraryType.FETCH_COLORS_GROUP,
      payload: (filterMasters.colorGroups || []).map((item) => ({ ...item, isDisable: false })),
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
